<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-6">
      <app-text-input
        controlName="medicalSupplierId"
        placeholder="MS-{{ msIdMaskConfig.mask }}"
        [maskConfig]="msIdMaskConfig"
      ></app-text-input>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-search-type-group">
        <app-select-input
          class="form-search-type-select"
          #nameSearchOptionTypeList
          controlName="nameSearchOptionType"
          [showNullPlaceholder]="false"
        ></app-select-input>
        <app-generic-input
          class="form-search-type-input"
          approvedNameCharacters
          controlName="medicalSupplierName"
        ></app-generic-input>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <app-generic-input controlName="nationalProviderIdentifier"></app-generic-input>
    </div>
    <div class="col-6">
      <app-select-input
        #medicalSupplierTypeList
        controlName="medicalSupplierTypeId"
        [showNullPlaceholder]="false"
      ></app-select-input>
    </div>
    <div class="col-3">
      <app-text-input
        controlName="fEIN"
        [maskConfig]="feinMaskConfig"
        (input)="onFeinChange()"
      ></app-text-input>
    </div>
  </div>
</form>
